import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { messages as msg } from '@env/environment';
import { Utils } from '@shared/utils';
import { TableService } from '@shared/components/table/table.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorManagementService {
  private _msg = msg;

  private readonly _router = inject(Router);
  private readonly _toastr = inject(ToastrService);
  private readonly _utils = inject(Utils);
  private readonly _tableSvc = inject(TableService);

  public errorEdit(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error.error?.message || this._msg.error_general;
    const title = error.error?.title || this._msg.error_actualizar_registro;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorCreate(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error.error?.message || this._msg.error_general;
    const title = error.error?.title || this._msg.no_creacion;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorGetById(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error?.error?.message || this._msg.error_general;
    const title = error.error?.title || this._msg.error_al_obtener_datos;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorDelete(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error?.error?.message || this._msg.error_general;
    const title = error.error?.title || this._msg.error_eliminar_registro;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorGetAll(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error.error?.message || this._msg.no_info;
    const title = error.error?.title || this._msg.error_al_obtener_datos;
    this._toastr.error(message, title);
    // this.timeout();
  }

  public errorNoFoundData(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error?.error?.message || this._msg.no_info;
    const title = error.error?.title || this._msg.no_hay_datos;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorTitle(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error.error?.message || this._msg.no_info;
    const title = error.error?.title || this._msg.title_error;
    this._toastr.error(message, title);
    this.timeout();
  }

  public errorBarraLateral(error: HttpErrorResponse) {
    this._toastr.error(this._msg.error_barra_lateral);
  }

  public errorDownloadReport(error: HttpErrorResponse) {
    if (error.error.status === 401) return this.getErrorStatus(401);
    const message = error.error?.message || this._msg.error_general;
    const title = error.error?.title || this._msg.error_descarga_archivo;
    this._toastr.error(message, title);
    this.timeout();
  }

  public status500(error: HttpErrorResponse) {
    this._toastr.error(this._msg.error_500_Desc, this._msg.error_500);
    this.timeout();
  }

  private getErrorStatus(status: number) {
    localStorage.clear();
    this._utils.deleteCookie('AUTH_SESSION_ID_LEGACY');
    this._utils.deleteCookie('KEYCLOAK_IDENTITY_LEGACY');
    this._utils.deleteCookie('_KC_RESTART');
    this._router.navigate(['login']);
    this._toastr.warning('Token vencido', 'Error al iniciar sessión');
    this.timeout();
  }

  private timeout(): void {
    setTimeout(() => {
      // this._router.navigate([redirectTo()]);
      this._tableSvc.setSpinner(true);
    }, 3000);
  }
}
